import { render, staticRenderFns } from "./UpdateSjlApprovalNoDialog.vue?vue&type=template&id=66efcfbc&"
import script from "./UpdateSjlApprovalNoDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateSjlApprovalNoDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSjlApprovalNoDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VContainer,
  VDialog,
  VTextField,
})
